module.exports = __webpack_public_path__ + "static/media/bombay.4a762d3d.svg";